import { render, staticRenderFns } from "./RuleBlock.vue?vue&type=template&id=21658458&"
import script from "./RuleBlock.vue?vue&type=script&lang=js&"
export * from "./RuleBlock.vue?vue&type=script&lang=js&"
import style0 from "./RuleBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports